import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';

import 'roboto-fontface/css/roboto/roboto-fontface.css'
import 'font-awesome/css/font-awesome.css'

import {format} from 'date-fns'
import VueMask from 'v-mask'

import MyUtil from './plugins/util'

console.log("process.env.VUE_APP_CONSOLE-->",!!process.env.VUE_APP_CONSOLE)

!!!process.env.VUE_APP_CONSOLE ? console.log = function() {} : console.log("LOG ACTIVADO")
!!!process.env.VUE_APP_CONSOLE ? console.table = function() {} : console.log("LOG ACTIVADO")


Array.prototype.chunk = function (chunk_size) {
  if ( !this.length ) {
      return [];
  }

  return [ this.slice( 0, chunk_size ) ].concat(this.slice(chunk_size).chunk(chunk_size));
};

Vue.use(MyUtil)

Vue.config.productionTip = false

Vue.filter('LEN', function (value) {
  return value.length
})

Vue.filter ('DDMMAAAA_HHMM', function (value) {
  if (!value) return ''
  return format(value ?new Date(value): Date.now(), 'dd-MM-yyyy HH:mm:ss.00')
})

Vue.filter ('DDMMAAAA', function (value) {
  if (!value) return ''
  return format(value ?new Date(value): Date.now(), 'dd-MM-yyyy')
})

Vue.use(VueMask)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')


